/**
 * Persist which organization the user picked immediately before we send them
 * through SSO, so we can re-apply that scope when they return. Stored in
 * `sessionStorage` because the SSO round-trip stays in the same tab and we
 * want the value to disappear once it's been consumed or the tab closes.
 *
 * Callers read the storage key inline (needed for the no-stale-read lint rule)
 * and use `clearPendingSsoOrgLogin` after commit so a StrictMode-abandoned
 * first render can't swallow the one-shot handshake.
 */
export const PENDING_SSO_ORG_STORAGE_KEY = 'copilot-task-composer:pending-sso-org'

export function setPendingSsoOrgLogin(login: string): void {
  try {
    sessionStorage.setItem(PENDING_SSO_ORG_STORAGE_KEY, login)
  } catch {
    // sessionStorage unavailable (e.g. private mode); silently drop — the SSO
    // return will just fall back to the default scope.
  }
}

export function clearPendingSsoOrgLogin(): void {
  try {
    sessionStorage.removeItem(PENDING_SSO_ORG_STORAGE_KEY)
  } catch {
    // Ignore — best-effort cleanup.
  }
}
